import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DashboardItemDirective } from './dashboard-item.directive';
import { GridStateDirective } from './grid-state.directive';
import { HideIfDashboardEditModeDirective } from './hide-if-dashboard-edit-mode.directive';
import { IfAllowedDirective } from './if-allowed.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [DashboardItemDirective, GridStateDirective, IfAllowedDirective, HideIfDashboardEditModeDirective],
    exports: [DashboardItemDirective, GridStateDirective, IfAllowedDirective, HideIfDashboardEditModeDirective]
})
export class DirectivesModule {}
